Dates = require 'lib/dates'
React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')('trello_card_attachment')

{
  CanonicalCard
  GenericErrorCanonicalCard
  InvalidCanonicalCard
  LoadingCanonicalCard
  NetworkErrorCanonicalCard
  NotFoundCanonicalCard
  UnauthorizedCanonicalCard
} = require 'views/canonical-card/canonical-card-components'

class TrelloCardAttachmentLoading extends React.Component
  displayName: 'TrelloCardAttachmentLoading'

  render: t.renderable ->
    t.div '.trello-card-attachment-loading', =>
      t.div '.trello-attachment-canonical-card', =>
        t.tag LoadingCanonicalCard

class TrelloCardAttachmentGenericError extends React.Component
  displayName: 'TrelloCardAttachmentGenericError'

  render: t.renderable ->
    { canEdit, errorText, onRemove } = @props

    t.div '.trello-card-attachment-error', =>
      t.div '.trello-attachment-canonical-card', =>
        t.tag GenericErrorCanonicalCard, { errorText }

      if onRemove and canEdit
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

class TrelloCardAttachmentUnauthorized extends React.Component
  displayName: 'TrelloCardAttachmentUnauthorized'

  render: t.renderable ->
    { canEdit, onRemove } = @props

    t.div '.trello-card-attachment-error', =>
      t.div '.trello-attachment-canonical-card', =>
        t.tag UnauthorizedCanonicalCard

      if onRemove and canEdit
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

class TrelloCardAttachmentSpecificError extends React.Component
  displayName: 'TrelloCardAttachmentSpecificError'

  render: t.renderable ->
    { canEdit, error, onRemove } = @props

    t.div '.trello-card-attachment-error', =>
      t.div '.trello-attachment-canonical-card', =>
        if error == 'bad request'
          t.tag InvalidCanonicalCard
        else if error == 'server'
          t.tag NetworkErrorCanonicalCard
        else
          t.tag NotFoundCanonicalCard

      if onRemove and canEdit
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

class TrelloCardAttachmentComponent extends React.Component
  displayName: 'TrelloCardAttachment'

  render: t.renderable ->
    {
      board
      canRemove
      canLink
      canUnarchive
      card
      isLinked
      labels
      list
      members
      numNotifications
      onLink
      onRemove
      onUnarchive
    } = @props

    isArchived = card.get('closed')

    t.div '.trello-card-attachment', =>
      t.div '.trello-attachment-canonical-card', =>
        t.tag CanonicalCard, {
          board
          card
          labels
          list
          members
          numNotifications
        }

      if canRemove
        t.a '.remove-trello-attachment', { onClick: onRemove }, =>
          t.format 'remove'

      if isArchived and canUnarchive
        t.a '.unarchive-trello-card', { onClick: onUnarchive }, =>
          t.span '.icon-sm.icon-archive'
          t.format 'unarchive card'

      if not isArchived and not isLinked and canLink
        t.a '.link-trello-card', { onClick: onLink }, =>
          t.format 'connect-ellipsis'

module.exports = {
  TrelloCardAttachmentComponent
  TrelloCardAttachmentGenericError
  TrelloCardAttachmentLoading
  TrelloCardAttachmentSpecificError
  TrelloCardAttachmentUnauthorized
}



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/trello-card-attachment-components.coffee